import ReactQuill from 'react-quill-new';
import QuillTableBetter from 'quill-table-better';
import 'quill-table-better/dist/quill-table-better.css';

ReactQuill.Quill.register(
	{'modules/table-better': QuillTableBetter},
	true,
);

export {QuillTableBetter};
